import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ReimburtInfoTravelApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'reimburtInfoTravel'
  }

}